import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useToaster } from 'Context/SnackbarContext';
import { isEmptyObject, showSnackBarMessage } from 'utils/HelperFunctions';
import { GET_ORG_WIDE_REDEMPTION_CONFIG } from 'Services/apiKeys';
import { getOrganisationWideRedemptionConfig } from 'Services/apiFunctions';
import PropTypes from 'prop-types';
import EnableRewards from './EnableRewards';
import { updateWorkspaceDetails } from 'redux/workspace/actions';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

const Index = ({ history }) => {
    const { SetSnackbar } = useToaster();
    const dispatch = useDispatch();
    const { config, nameForPoints } = useSelector(mapStateToProps, shallowEqual);
    const [enableRewards, setEnableRewards] = useState(false);

    const { data } = useQuery([GET_ORG_WIDE_REDEMPTION_CONFIG], getOrganisationWideRedemptionConfig, {
        onSuccess: ({ data }) => {
            if (!isEmptyObject(data)) {
                updateWorkspaceDetails(dispatch, {
                    config: { ...config, conversion: data?.conversions },
                });
                setEnableRewards(data?.redemption);
            }
        },
        onError: (error) => showSnackBarMessage(SetSnackbar, 'error', error?.message),
    });

    return (
        <div>
            <EnableRewards
                history={history}
                conversions={data?.data?.conversions}
                config={config}
                nameForPoints={nameForPoints}
                enableRewards={enableRewards}
                setEnableRewards={setEnableRewards}
            />
        </div>
    );
};

const mapStateToProps = ({ Workspace }) => ({
    nameForPoints: Workspace.nameForPoints,
    config: Workspace.config,
});

Index.propTypes = {
    history: PropTypes.object,
};

export default Index;
